import { SERVICES_AN_ERROR_OCCURRED_LOADING } from 'common/constants/services/services';
import { FIRM_SUMMARY_MEASUREMENT_DATES_TITLE, FIRM_SUMMARY_TITLE } from 'pages/Firms/common/constants';

export const SERVICES_FIRMS_REFETCH_ON_WINDOW_FOCUS = false;

// Company list by firm
export const COMPANY_LIST_BY_FIRM_QUERY_KEY = 'COMPANY_LIST_BY_FIRM';
export const COMPANY_LIST_BY_FIRM_TITLE = 'Companies';
export const COMPANY_LIST_BY_FIRM_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(COMPANY_LIST_BY_FIRM_TITLE);

// Firm Tasks Progress
export const TASKS_PROGRESS_BY_FIRM_QUERY_KEY = 'TASKS_PROGRESS_BY_FIRM';
export const TASKS_PROGRESS_BY_FIRM_TITLE = 'Firm Tasks Progress';
export const TASKS_PROGRESS_BY_FIRM_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(TASKS_PROGRESS_BY_FIRM_TITLE);

// Firm Task Progress Details
export const TASK_PROGRESS_DETAILS_QUERY_KEY = 'TASK_PROGRESS_DETAILS';
export const TASK_PROGRESS_DETAILS_TITLE = 'Firm Tasks Progress';
export const TASK_PROGRESS_DETAILS_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(TASK_PROGRESS_DETAILS_TITLE);

// Measurement dates by firm
export const MEASUREMENT_DATES_BY_FIRM_QUERY_KEY = 'MEASUREMENT_DATES_BY_FIRM';
export const MEASUREMENT_DATES_BY_FIRM_TITLE = FIRM_SUMMARY_MEASUREMENT_DATES_TITLE;
export const MEASUREMENT_DATES_BY_FIRM_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  MEASUREMENT_DATES_BY_FIRM_TITLE
);

// Merged company/fund measurement dates by firm
export const MERGED_MEASUREMENT_DATES_BY_FIRM_QUERY_KEY = 'MERGED_MEASUREMENT_DATES_BY_FIRM';
export const MERGED_MEASUREMENT_DATES_BY_FIRM_TITLE = 'Merged Firm Measurement Dates';
export const MERGED_MEASUREMENT_DATES_BY_FIRM_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  MERGED_MEASUREMENT_DATES_BY_FIRM_TITLE
);

// Company and fund measurement-date rows by firm/date
export const MEASUREMENT_DATE_ROWS_BY_FIRM_DATE_QUERY_KEY = 'MEASUREMENT_DATE_ROWS_BY_FIRM_DATE';
export const MEASUREMENT_DATE_ROWS_BY_FIRM_DATE_TITLE = 'Measurement Date Rows';
export const MEASUREMENT_DATE_ROWS_BY_FIRM_DATE_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  MEASUREMENT_DATE_ROWS_BY_FIRM_DATE_TITLE
);

// Firm summary
export const FIRM_SUMMARY_QUERY_KEY = 'FIRM_SUMMARY';
export const FIRM_SUMMARY_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(FIRM_SUMMARY_TITLE);

// Firm investments (schedule of investments under Intelligence)
export const FIRM_INVESTMENTS_BY_MD_QUERY_KEY = 'FIRM_INVESTMENTS_BY_MD';
export const FIRM_INVESTMENTS_BY_MD_TITLE = 'Firm Investments';
export const FIRM_INVESTMENTS_BY_MD_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(FIRM_INVESTMENTS_BY_MD_TITLE);

// Fund list by firm
export const FUND_LIST_BY_FIRM_QUERY_KEY = 'FUND_LIST_BY_FIRM';
export const FUND_LIST_BY_FIRM_TITLE = 'Funds';
export const FUND_LIST_BY_FIRM_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(FUND_LIST_BY_FIRM_TITLE);

// Firm users with permissions
export const FIRM_COMPANY_USER_PERMISSIONS_QUERY_KEY = 'FIRM_COMPANY_USER_PERMISSIONS';
export const FIRM_COMPANY_USER_PERMISSIONS_STALE_TIME = 1000 * 60;

// Firm summary definition data
export const FIRM_SUMMARY_DEFINITION_DATA_QUERY_KEY = 'FIRM_SUMMARY_DEFINITION_DATA';
export const FIRM_SUMMARY_DEFINITION_DATA_STALE_TIME = 5 * 60 * 1000; // 5 min — data only changes on explicit save
export const FIRM_SUMMARY_DEFINITION_DATA_TITLE = 'Firm Summary Definition Data';
export const FIRM_SUMMARY_DEFINITION_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_SUMMARY_DEFINITION_DATA_TITLE
);

// Dashboard-kind definition data (resolved component values)
// One key serves both the summary and valuations surfaces; the summaryType is a key segment.
export const FIRM_DASHBOARD_DATA_QUERY_KEY = 'FIRM_DASHBOARD_DATA';
export const FIRM_DASHBOARD_DATA_STALE_TIME = 5 * 60 * 1000; // matches the spreadsheet data cache
export const FIRM_DASHBOARD_DATA_TITLE = 'Dashboard Data';
export const FIRM_DASHBOARD_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_DASHBOARD_DATA_TITLE
);

// Firm summary definition chart data (trending across measurement dates)
export const FIRM_SUMMARY_DEFINITION_CHART_DATA_QUERY_KEY = 'FIRM_SUMMARY_DEFINITION_CHART_DATA';
export const FIRM_SUMMARY_DEFINITION_CHART_DATA_STALE_TIME = 5 * 60 * 1000;
export const FIRM_SUMMARY_DEFINITION_CHART_DATA_TITLE = 'Firm Summary Chart Data';
export const FIRM_SUMMARY_DEFINITION_CHART_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_SUMMARY_DEFINITION_CHART_DATA_TITLE
);

// Firm valuations definition data
export const FIRM_VALUATIONS_DEFINITION_DATA_QUERY_KEY = 'FIRM_VALUATIONS_DEFINITION_DATA';
export const FIRM_VALUATIONS_DEFINITION_DATA_STALE_TIME = 5 * 60 * 1000;
export const FIRM_VALUATIONS_DEFINITION_DATA_TITLE = 'Firm Valuations Definition Data';
export const FIRM_VALUATIONS_DEFINITION_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_VALUATIONS_DEFINITION_DATA_TITLE
);

// Firm valuations definition chart data (trending across measurement dates)
export const FIRM_VALUATIONS_DEFINITION_CHART_DATA_QUERY_KEY = 'FIRM_VALUATIONS_DEFINITION_CHART_DATA';
export const FIRM_VALUATIONS_DEFINITION_CHART_DATA_STALE_TIME = 5 * 60 * 1000;
export const FIRM_VALUATIONS_DEFINITION_CHART_DATA_TITLE = 'Firm Valuations Chart Data';
export const FIRM_VALUATIONS_DEFINITION_CHART_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_VALUATIONS_DEFINITION_CHART_DATA_TITLE
);

// Daily NAV records by firm/date
export const DAILY_NAV_RECORDS_BY_FIRM_QUERY_KEY = 'DAILY_NAV_RECORDS_BY_FIRM';
export const DAILY_NAV_RECORDS_BY_FIRM_TITLE = 'Daily NAV Records';
export const DAILY_NAV_RECORDS_BY_FIRM_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  DAILY_NAV_RECORDS_BY_FIRM_TITLE
);

// Daily NAV price override form (per record)
export const DAILY_NAV_OVERRIDE_FORM_QUERY_KEY = 'DAILY_NAV_OVERRIDE_FORM';

